import React from 'react';
import style from '../../Components/LazyLoading/LazyLoading.module.css';
import loading from '../../assets/Dia con neblina.jpg';

export default function LazyLoading(){
    return(
        <div className={style.gralLazyLoading}>
            {/* <img id={style.imgLazy} src={loading} alt="Cargando..."></img> */}
       </div>
    )
}